import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const HumanLoss: Portfolio = {
    path: "human-loss", name: "Human Loss", pageStyle: PageStyle.Tan, pieces: [
        {image: "human-loss-01.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 1", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-02.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 2", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-03.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 3", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-04.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 4", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-05.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 5", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-06.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 6", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-07.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 7", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-08.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 8", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
        {image: "human-loss-09.jpg", thumbAlt: "Human Loss", title: "Human Loss\nPanel 9", size: "8 \u00d7 8", pixelWidth: 360, pixelHeight: 360},
    ],
    piecesNote: "These prints are a grid of nine pieces that exist as a unit, intended to be shown together.\n" +
        "Process: Intaglio prints on Zerkall Printmaking Paper, adhered to birch board.",
    statementTitle: "Human Loss: … Human Loss",
    statement: {
        leftColumn: [
            "These images were photographed on Patan Square, Kathmandu, Nepal after the 2015 Earthquake.",
            "Initially, I wished to symbolize the loss of life from the quake. I chose to connect my work to the " +
            "extraction of oil from the earth, and how the water waste from oil extraction contributes to earthquakes.",
            "As I worked, these images took on a more expansive meaning, symbolizing the considerable loss of human " +
            "life due directly and indirectly to countless \"extractions\" globally. These include consumer " +
            "societies that are voraciously draining the earth of natural resources to satisfy an insatiable need " +
            "for material goods and comforts. All of this activity leads to forests dying, the oceans being drained " +
            "of fish, natural disasters, and climate change."
        ],
        rightColumn: [
            "As a result, people are migrating, in search of a place on earth where they can have a viable life. " +
            "The shadows in the images represent the value, and the aspirations, of each human being.",
            "Process: Intaglio prints on Zerkall Printmaking Paper, adhered to birch board.",
            "Erika Radich\nSeptember 2020"
        ],
    }
};

export default HumanLoss;